import { Flex, Text, Button, CloseIcon } from "@fluentui/react-northstar";
import { useChatStore } from "../../stores/useChatStore";
import MessagesContainer from "./MessageContainer";
import InputArea from "./InputArea";
import styled from "styled-components";
import { DEVICE } from "../../constants/responsive";
import { Loader } from "@fluentui/react-northstar";
import Yeetchicon from "../../assets/chatbot/Yeetchi v2.svg";

const ChatWindow = ({
    newResponse,
    histories,
    isLoadingHistories = false,
    isLoadingResponse = false,
    currentQuestion,
    onAskQuestion,
}) => {
    const { isOpen, toggleChat } = useChatStore();

    if (!isOpen) return null;

    return (
        <FlexChatWindow column>
            <Flex
                vAlign="center"
                space="between"
                styles={{
                    padding: "16px 20px",
                    backgroundColor: "var(--color-primary)",
                    borderBottom: "1px solid #E1DFDD",
                }}
            >
                <Text
                    content={
                        <Flex vAlign="center" gap="gap.small">
                            <img
                                src={Yeetchicon}
                                alt="Yeetch Icon"
                                style={{ width: 30 }}
                            />
                            <Text content="Chatbot Yeetch" />
                        </Flex>
                    }
                    weight="semibold"
                    size="large"
                    styles={{ color: "white" }}
                />
                <Button
                    text
                    icon={<CloseIcon />}
                    iconOnly
                    onClick={toggleChat}
                    aria-label="Close chat"
                    styles={{
                        color: "white",
                        minWidth: "auto",
                        ":hover": {
                            backgroundColor: "rgba(255, 255, 255, 0.1)",
                        },
                    }}
                />
            </Flex>
            {isLoadingHistories ? (
                <Flex fill hAlign="center" vAlign="center">
                    <Loader label={"Chargement"} />
                </Flex>
            ) : (
                <MessagesContainer
                    histories={histories}
                    isLoadingResponse={isLoadingResponse}
                    currentQuestion={currentQuestion}
                    newResponse={newResponse}
                />
            )}
            <InputArea onAskQuestion={onAskQuestion} />
        </FlexChatWindow>
    );
};

export default ChatWindow;

const FlexChatWindow = styled(Flex)`
    position: fixed;
    background-color: white;
    border-radius: 8px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
    overflow: hidden;
    border: 1px solid #e1dfdd;
    max-height: auto;

    @media ${DEVICE.mobileS} {
        right: 0px;
        bottom: 0px;
        z-index: 1001;

        width: 100%;
        height: 100dvh;
    }

    @media ${DEVICE.mobileL} {
        right: 24px;
        bottom: 100px;
        z-index: 999;

        width: 380px;
        height: calc(100vh - 180px);
        max-height: 600px;
    }
`;
